import { Component } from "react";
import { Navigate } from "react-router-dom";

import { CommonService } from "../js_modules/CommonService";

import { SellToWebAdminPageComponent } from "../common/selltowebpage/SellToWebAdminPageComponent";
import { SellToWebInputComponent } from "../common/selltowebinput/SellToWebInputComponent"

import { XSRFTest2QueryComponent } from "./XSRFTest2QueryComponent";

export class XSRFTest2RouteComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadingData: false,
            token: "",
            vin: "Test1",
            redirectTo: ""
        };

        this.onChange = this.onChange.bind(this);
        this.onGetPageInfo = this.onGetPageInfo.bind(this);
        this.onActionWithValidation = this.onActionWithValidation.bind(this);
        this.onActionWithoutValidation = this.onActionWithoutValidation.bind(this);
        this.onGoToXSRF1 = this.onGoToXSRF1.bind(this);
        this.onGoToXSRF3 = this.onGoToXSRF3.bind(this);
    }

    pageTitle = "XSRF Test 2";

    componentDidMount() {
        try {
            this.props.onPageLoad({ pageTitle: this.pageTitle });
            this.setState({ token: CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS") });
        }
        catch (error) {
            console.logError(error, "XSRFTest2RouteComponent", "componentDidMount");
        }
    }

    onGetPageInfo() {
        try {
            this.setState({ isLoadingData: true });
            this.props.applicationInsights.trackTrace({ message: "XSRFTest2RouteComponent/onGetPageInfo", properties: { logon: this.props.logon } });
            fetch("/XSRFTest2/GetPageInfo", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;",
                    "X-XSRF-TOKEN-ACQUIRECARS": this.state.token
                },
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        token: CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS"),
                        isLoadingData: false
                    });
                })
                .catch(notOKResponse => {
                    this.props.onShowAlert("danger", { message: "Get Page Info Failed." });
                    this.setState({
                        isLoadingData: false
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/XSRFTest2/ValidateWithKey", ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "XSRFTest2RouteComponent", "onGetPageInfo");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "XSRFTest2RouteComponent", "onGetPageInfo");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "XSRFTest2RouteComponent", "onGetPageInfo");
        }
    }

    onChange(id, value) {
        try {
            this.setState({ [id]: value })
        }
        catch (error) {
            console.logError(error, "XSRFTest2RouteComponent", "onChange");
        }
    }

    onActionWithValidation() {
        try {
            this.setState({ isLoadingData: true });
            this.props.applicationInsights.trackTrace({ message: "XSRFTest2RouteComponent/onActionWithValidation", properties: { logon: this.props.logon } });

            let inputData = {
                vin: this.state.vin
            };
            fetch("/XSRFTest2/ActionWithValidation", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;",
                    "X-XSRF-TOKEN-ACQUIRECARS": this.state.token
                },
                credentials: "same-origin",
                body: JSON.stringify(inputData)
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        token: CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS"),
                        isLoadingData: false
                    });
                    if (parsedResponse.success) {
                        this.props.onShowAlert("success", { message: "Anti-Forgery Validation Successfull.!" }, 4000);
                    }
                    else {
                        this.props.onShowAlert("danger", { message: "Anti-Forgery Validation Failed." });
                    }
                    this.setState({ isLoadingData: false });
                })
                .catch(notOKResponse => {
                    this.props.onShowAlert("danger", { message: "Anti-Forgery Validation Failed." });
                    this.setState({
                        isLoadingData: false
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/XSRFTest2/ActionWithValidation", ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "XSRFTest2RouteComponent", "onActionWithValidation");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "XSRFTest2RouteComponent", "onActionWithValidation");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "XSRFTest2RouteComponent", "onActionWithValidation");
        }
    }

    onActionWithoutValidation() {
        try {
            this.setState({ isLoadingData: true });
            this.props.applicationInsights.trackTrace({ message: "XSRFTest2RouteComponent/onActionWithoutValidation", properties: { logon: this.props.logon } });
            fetch("/XSRFTest2/ActionWithoutValidation", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    if (parsedResponse.success) {
                        this.props.onShowAlert("success", { message: "Anti-Forgery Validation Skipped.!" }, 4000);
                    }
                    else {
                        this.props.onShowAlert("danger", { message: "Anti-Forgery Validation Skip Failed." });
                    }
                    this.setState({ isLoadingData: false });
                })
                .catch(notOKResponse => {
                    this.props.onShowAlert("danger", { message: "Anti-Forgery Validation Skipped." });
                    this.setState({
                        isLoadingData: false
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/XSRFTest2/ActionWithoutValidation", ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "XSRFTest2RouteComponent", "onActionWithoutValidation");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "XSRFTest2RouteComponent", "onActionWithoutValidation");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "XSRFTest2RouteComponent", "onActionWithoutValidation");
        }
    }

    onGoToXSRF1() {
        try {
            this.setState({
                redirectTo: "/Demo/XSRFTest1"
            });
        }
        catch (error) {
            console.logError(error, "XSRFTest2RouteComponent", "onGoToXSRF1");
        }
    }

    onGoToXSRF3() {
        try {
            this.setState({
                redirectTo: "/Demo/XSRFTest3"
            });
        }
        catch (error) {
            console.logError(error, "XSRFTest2RouteComponent", "onGoToXSRF3");
        }
    }

    render() {
        if (this.state.redirectTo) {
            console.log("Redirecting to ", this.state.redirectTo);
            return <Navigate to={this.state.redirectTo} />;
        }
        return <SellToWebAdminPageComponent>
            <div className="admin-flex-item admin-body">
                <div className="d-flex flex-column admin-fill-content">
                    <XSRFTest2QueryComponent isLoadingData={this.state.isLoadingData} onShowAlert={this.props.onShowAlert} applicationInsights={this.props.applicationInsights}
                        onGetPageInfo={this.onGetPageInfo} onActionWithValidation={this.onActionWithValidation} onActionWithoutValidation={this.onActionWithoutValidation}
                        onGoToXSRF1={this.onGoToXSRF1} onGoToXSRF3={this.onGoToXSRF3} />
                    <br />
                    <div className="card">
                        <div className="card-block" style={{ "padding": "10px" }}>
                            <strong>Page Cookies:</strong><br />
                            {decodeURIComponent(document.cookie)}<br /><br />
                            <strong>XSRF Token:</strong><br />
                            {CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS")}<br /><br />
                            <SellToWebInputComponent id="token" value={this.state.token} label="Token" onTextChange={this.onChange} />
                            <SellToWebInputComponent id="vin" value={this.state.vin} label="VIN" onTextChange={this.onChange} />
                        </div>
                    </div>
                </div>
            </div>
        </SellToWebAdminPageComponent>;
    }
}